import {Dispatch} from 'redux';
import {makeUrl, post} from '../../utils/fetcher';
import {METHODS} from '../../constants';
import {GeneratedTOTPSecretResult} from '../../types/TOTP';

export const generateTOTPSecret = (
  isInitial: boolean,
  // eslint-disable-next-line no-unused-vars
  callback: (result: GeneratedTOTPSecretResult) => void,
) => {
  const url = makeUrl(isInitial ? METHODS.INIT_TOTP_SECRET : METHODS.GENERATE_TOTP_SECRET);
  return (dispatch: Dispatch) => post(url, {}, dispatch)
    .then((response) => {
      if (response && response.data) {
        callback(response.data);
      }
    });
};

export const validateTOTPSecret = (
  code: string,
  isInitial: boolean,
  // eslint-disable-next-line no-unused-vars
  callback: (result: boolean, data: { [key: string]: string | number | boolean }) => void,
) => {
  const path = isInitial ? METHODS.AUTH2FA : METHODS.VALIDATE_TOTP_SECRET;
  const url = makeUrl(path, {code});
  return (dispatch: Dispatch) =>
    post(url, {code}, dispatch, false)
      .then((response) =>
        callback(
          !!response?.success && (!isInitial || !!response?.data?.authCodeChecked),
          response?.data ?? {},
        ),
      )
      .catch(() => callback(false, {}));
};
